import { create } from 'zustand';
import { InventoryOrder, ResendPayload } from '@/types/inventory';

interface ResendState {
  selectedOrders: InventoryOrder[];
  currentStep: number;
  orderOverrides: Record<string, ResendPayload>;

  setSelectedOrders: (orders: InventoryOrder[]) => void;
  setCurrentStep: (step: number) => void;
  setOrderOverride: (uid: string, data: ResendPayload) => void;
  reset: () => void;
}

export const useResendStore = create<ResendState>((set) => ({
  selectedOrders: [],
  currentStep: 0,
  orderOverrides: {},

  setSelectedOrders: (orders) =>
    set({
      selectedOrders: orders,
      currentStep: 0,
      orderOverrides: {},
    }),
  setCurrentStep: (step) => set({ currentStep: step }),
  setOrderOverride: (uid, data) =>
    set((state) => ({
      orderOverrides: { ...state.orderOverrides, [uid]: data },
    })),
  reset: () =>
    set({
      selectedOrders: [],
      currentStep: 0,
      orderOverrides: {},
    }),
}));
